import React, { Component } from 'react'
import get from 'lodash/get'
import InfoBlock from '../components/shared/infoBlock'
import UniversityCard from '../components/shared/graphicCard'
import Collapsable from '../components/shared/collapsable'
import AngleBracketButton from '../components/shared/angleBracketButton'
import { Mobile, Default, isNarrowDesktop, isTablet } from '../media-queries'
import Helmet from 'react-helmet'
import WWAnimation from '../components/homepage/worldwideAnimation'

export default class Universities extends Component {
  render() {
    const [{ node: data }] = get(
      this,
      'props.data.allContentfulUniversitiesPage.edges'
    )
    return (
      <div
        style={{
          background: '#f7f7f7',
          fontFamily: "'Libre Franklin', 'sans serif'",
        }}
      >
        <Helmet
          title={'IMRD - Universities'}
          meta={[
            { name: 'description', content: 'universities' },
            {
              name: 'keywords',
              content: 'IMRD, UGent, partners, partnership, universities, eu, europe, european, international'
                .concat(data.euPartners.map(({ name }) => `, ${name}`))
                .concat(data.nonEuPartners.map(({ name }) => `, ${name}`)),
            },
          ]}
        />
        <Default>
          <DefaultUniversities
            style={{ minHeight: 'calc(100vh - 255px)' }}
            data={data}
          />
        </Default>
        <Mobile>
          <MobileUniversities data={data} />
        </Mobile>
      </div>
    )
  }
}

class DefaultUniversities extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 'none',
      columns: [],
      cardWidth: this.getCardWidth(),
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateCards)
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateCards)
    }
  }

  inColumns = dataRange => {
    const range = []
    for (let i = 1; i <= this.getNumberOfColumns(); i++) {
      range.push([])
    }
    dataRange.forEach((data, i) =>
      range[i % this.getNumberOfColumns()].push(data)
    )
    return range
  }

  getNumberOfColumns = () => (isNarrowDesktop() || isTablet() ? 2 : 3)

  getColumns = target => {
    if (target === 'eu') {
      return this.inColumns([...this.props.data.euPartners])
    } else if (target === 'int') {
      return this.inColumns([...this.props.data.nonEuPartners])
    }
    return []
  }

  updateCards = () =>
    this.setState(prevState => ({
      cardWidth: this.getCardWidth(),
      columns: this.getColumns(prevState.active),
    }))

  getCardWidth = () => {
    if (typeof window !== 'undefined') {
      if (isTablet())
        return (
          (window.innerWidth - 6 * 18 - this.getNumberOfColumns() * 18) /
          this.getNumberOfColumns()
        )
      else
        return (
          (window.innerWidth - 8 * 18 - this.getNumberOfColumns() * 18) /
          this.getNumberOfColumns()
        )
    }
  }

  setActive = target => {
    this.setState(prevState => ({
      columns: this.getColumns(target),
      active: prevState.active === target ? 'none' : target,
    }))
  }

  render() {
    const { data, style } = this.props
    return (
      <div style={style}>
        <div
          style={{
            padding: isTablet() ? '2rem 4rem 3rem' : '2rem 5rem 3rem',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            background: '#F7F7F7',
          }}
        >
          <InfoBlock
            style={{
              width: '67%',
              paddingRight: '1rem',
            }}
            title={data.title}
            bigTitle={true}
            text={data.text.internal.content}
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 'auto',
              marginBottom: '-3rem',
            }}
          >
            <div style={{ paddingBottom: '1rem' }}>
              <AngleBracketButton
                hasCaret={true}
                caretDirection={this.state.active === 'eu' ? 'down' : 'up'}
                hasShadow={this.state.active !== 'eu'}
                text={'EU Partners'}
                style={{
                  minWidth: '250px',
                  background: this.state.active === 'eu' ? '#8CBD8C' : 'white',
                }}
                onClick={() => this.setActive('eu')}
              />
            </div>
            <div style={{ zIndex: 100 }}>
              <AngleBracketButton
                hasCaret={true}
                hasShadow={this.state.active !== 'int'}
                caretDirection={this.state.active === 'int' ? 'down' : 'up'}
                text={'International Partners'}
                style={{
                  minWidth: '250px',
                  background: this.state.active === 'int' ? '#8CBD8C' : 'white',
                }}
                onClick={() => this.setActive('int')}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            padding: isTablet() ? '3rem 2.5rem' : '3rem 3.5rem',
            marginTop: '-1.5rem',
            background: this.state.active === 'eu' ? '#8CBD8C' : '#f7f7f7',
            display: 'flex',
            height: '100%',
            flexDirection: 'row',
          }}
          className="transition"
        >
          {this.state.active === 'none' && (
            <div style={{ margin: '0 auto', paddingLeft: '5vw' }}>
              <WWAnimation viewWidth={50} />
            </div>
          )}
          {this.state.active !== 'none' &&
            this.state.columns.map((column, i) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                }}
                key={`column-${i}`}
              >
                {column.map(({ image, name, text, url }, i) => (
                  <div
                    key={i}
                    style={{
                      width: this.state.cardWidth,
                      margin: '0.5rem',
                    }}
                  >
                    <UniversityCard
                      title={name}
                      image={image}
                      route={uri(url || name)}
                      text={text.internal.content}
                    />
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    )
  }
}

const MobileUniversities = ({ data }) => (
  <div>
    <InfoBlock
      style={{
        padding: '1rem 2rem 1rem',
        background: '#F7F7F7',
      }}
      title={data.title}
      text={data.text.internal.content}
    />
    <div
      style={{
        background:
          'linear-gradient(to bottom, #F7F7F7, #F7F7F7 2.5rem, #8CBD8C 2.5rem, #8CBD8C)',
        padding: '1rem 1rem 3rem',
      }}
    >
      <Collapsable text="EU Partners">
        <div>
          {data.euPartners.map(({ image, name, text, url }, i) => (
            <div key={`${i}-${name}`}>
              <UniversityCard
                title={name}
                image={image}
                route={uri(url || name)}
                text={text.internal.content}
                style={{ marginTop: '0.5rem' }}
              />
            </div>
          ))}
        </div>
      </Collapsable>

      <Collapsable text="International Partners" style={{ marginTop: '1rem' }}>
        <div>
          {data.nonEuPartners.map(({ image, name, text, url }, i) => (
            <div style={{ marginBottom: '0.5rem' }} key={`${i}-${name}`}>
              <UniversityCard
                title={name}
                image={image}
                route={uri(url || name)}
                text={text.internal.content}
              />
            </div>
          ))}
        </div>
      </Collapsable>
    </div>
  </div>
)

const uri = name =>
  `/universities/${encodeURI(
    name
      .toLowerCase()
      .replace(/[^a-z0-9_\- ]/g, '')
      .split(' ')
      .join('-')
  )}`

export const UniversitiesQuery = graphql`
  query Universities {
    allContentfulUniversitiesPage {
      edges {
        node {
          title
          text {
            internal {
              content
            }
          }
          euPartners {
            name
            url
            text {
              internal {
                content
              }
            }
            image {
              sizes(maxWidth: 150) {
                src
              }
            }
          }
          nonEuPartners {
            name
            url
            text {
              internal {
                content
              }
            }
            image {
              sizes(maxWidth: 150) {
                src
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/universities.js